import { Injectable } from '@angular/core';
import { find, includes, result, uniq, without } from 'lodash';
import { LocalStorageService } from '../../shared/services/web-storage/local-storage/local-storage.service';
import StudentPanelsConfig from '../student-container/student-panels.config';

export type TValidStoredPanels =
  | 'student-basic-info-panel'
  | 'student-attendance-panel'
  | 'student-supports-panel'
  | 'student-academic-panel'
  | 'student-snapshot-panel'
  | 'student-grad-planning-panel'
  | 'student-grad-panel-v3'
  | 'student-current-program-panel'
  | 'student-credits-panel'
  | 'student-credit-gaps-panel'
  | 'student-regents-panel'
  | 'student-notes-panel'
  | 'student-full-exam-history-panel'
  | 'student-full-transcript-history-panel'
  | 'student-point-people-panel'
  | 'remote-learning-panel'
  | 'student-postsec-panel';

@Injectable()
export class StudentPanelService {
  constructor(private localStorage: LocalStorageService) {}

  getInitialPanelState(panelTitle: TValidStoredPanels): boolean {
    return includes(this.localStorage.getItem('ssvCollapsedPanels'), panelTitle);
  }

  getInitialPanelStateBasedOnHuman(panelTitle: string): boolean {
    const panelId = result(find(StudentPanelsConfig, { human: panelTitle }), 'id');
    if (!panelId) console.warn(`Unable to find ${panelTitle}`);
    const storage = this.localStorage.getItem('ssvCollapsedPanels');
    return includes(storage, panelId);
  }

  togglePanelBody(collapsed: boolean, panelTitle: string): boolean {
    const panelId = result(find(StudentPanelsConfig, { human: panelTitle }), 'id');
    if (!panelId) console.warn(`Unable to find ${panelTitle}`);

    if (collapsed) {
      let collapsedPanels = JSON.parse(localStorage.getItem('ssvCollapsedPanels')) || [];
      let openPanels = JSON.parse(localStorage.getItem('ssvOpenPanels')) || [];

      collapsedPanels = without(collapsedPanels, panelId);
      openPanels.push(panelId);
      openPanels = uniq(openPanels);

      this.localStorage.setItem('ssvCollapsedPanels', collapsedPanels);
      this.localStorage.setItem('ssvOpenPanels', openPanels);
      return false;
    } else {
      let collapsedPanels = JSON.parse(localStorage.getItem('ssvCollapsedPanels')) || [];
      let openPanels = JSON.parse(localStorage.getItem('ssvOpenPanels')) || [];

      openPanels = without(openPanels, panelId);
      collapsedPanels.push(panelId);
      collapsedPanels = uniq(collapsedPanels);

      this.localStorage.setItem('ssvOpenPanels', openPanels);
      this.localStorage.setItem('ssvCollapsedPanels', collapsedPanels);
      return true;
    }
  }
}
